<div style="width: 100%; height: 100%;" class="{{guid}} resizingTextFieldContainer" *ngIf="ngMaxLength">
<textarea style="width:100%; overflow: hidden; box-sizing: border-box; resize: none; color: black !important;"
          class="{{guid}} k-input k-textbox" name="{{ngId}}"
          [(ngModel)]="ngModel"
          (ngModelChange)="onNgChange()"
          (keydown)="onNgChange()"
          [attr.id]="ngId"
          [maxlength]="ngMaxLength"></textarea>
</div>

<div style="width: 100%; height: 100%;" class="{{guid}} resizingTextFieldContainer" *ngIf="!ngMaxLength">
<textarea style="width:100%; overflow: hidden; box-sizing: border-box; resize: none; color: black !important;"
          class="{{guid}} k-input k-textbox" name="{{ngId}}"
          [(ngModel)]="ngModel"
          (ngModelChange)="onNgChange()"
          (keydown)="onNgChange()"
          [attr.id]="ngId"></textarea>
</div>
